<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="card bg-white">
          <div class="card-header bg-gray-100">
            <p class="text-semibold no-margin">
              Usuários Backoffice | {{id}}
            </p>
            <div class="heading-elements">
              <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
            </div>
          </div>

          <div class="box-body">
            <div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

            <div class="form-group col-12 col-md-6">
              <label for="nome">Nome: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.nome }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="status_desc">Status: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.status_desc }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cpf">CPF: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.cpf }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="telefone">Telefone: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.telefone }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="email">E-mail: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.email }}
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="perfil">Perfil: &nbsp;&nbsp;&nbsp;</label>
              {{ registro.perfil.nome }}
            </div>
          </div>

          <div class="box-footer text-center">
            <div class="btn-group">
              <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Voltar</button>
              <button type="button" id="editarButton" class="btn btn-info" @click="editar()">Editar</button>
              <button type="button" id="gravarButton" class="btn btn-primary" @click="$modal.show('modal-alterar-senha')">Alterar senha</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <modal name="modal-alterar-senha" :adaptive="false" class="p-5" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-alterar-senha')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">Alterar senha</h3>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label for="novaSenha">Nova senha <sup class="text-danger">* </sup></label>
            <input id="novaSenha" v-model="registro.novaSenha" type="password" class="form-control" v-bind:class="{ 'box-input-required': errors.novaSenha }">
            <span v-show="errors.novaSenha != null" class="help-inline">{{ errors.novaSenha }}</span>
          </div>

          <div class="form-group ">
            <label for="confirmaSenha">Confirmar senha <sup class="text-danger">* </sup></label>
            <input id="confirmaSenha" v-model="registro.confirmaSenha" type="password" class="form-control" v-bind:class="{ 'box-input-required': errors.confirmaSenha }">
            <span v-show="errors.confirmaSenha != null" class="help-inline">{{ errors.confirmaSenha }}</span>
          </div>
        </div>

        <div class="modal-footer" style="">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-alterar-senha')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="alterarSenha()">Confirmar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { formatCpf } from '@brazilian-utils/formatters'
import Formatters from '../../helpers/Formatters'
import UsuarioActions from '../../actions/UsuarioActions'

export default {
  name: 'detalhes',
  props: ['id'],
  data () {
    return {
      strongRegex: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'),
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
        novaSenha: '',
        confirmaSenha: '',
        cd_perfil: '',
        cd_sistema: '',
        idc_status: '',
        status_desc: '',
        perfil: {
          nome: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Detalhes'

    UsuarioActions.obterUsuario(this.id)
      .then(res => {
        if (res && res.nome) {
          this.registro = res

          this.registro.cpf = formatCpf(this.registro.cpf)
          this.registro.telefone = Formatters.formataNumeroTelefone(this.registro.telefone)

          this.registro.perfil = this.registro.perfil === null ? { nome: null } : this.registro.perfil
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/usuarios')
    },
    editar () {
      this.$router.push('/usuarios/' + this.id + '/e')
    },

    validarSenha () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.novaSenha) {
        this.errors.novaSenha = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.confirmaSenha) {
        this.errors.confirmaSenha = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (this.registro.novaSenha !== this.registro.confirmaSenha) {
        this.errors.confirmaSenha = 'As senhas não coincidem.'
        this.hasError = true
      } else if (this.registro.confirmaSenha.length < 8) {
        this.errors.confirmaSenha = 'A senha deve conter ao menos 8 caracteres.'
        this.hasError = true
      } else if (!this.strongRegex.test(this.registro.confirmaSenha)) {
        this.errors.confirmaSenha = 'A senha deve combinar letras maiúsculas, minúsculas, números e um dos seguintes caracteres "!@#$%^&*".'
        this.hasError = true
      }
    },

    alterarSenha () {
      this.$parent.$parent.$data.showModalLoader = true

      this.validarSenha()

      if (!this.hasError) {
        UsuarioActions.alterarSenha(this.id, this.registro.confirmaSenha, this, '/usuarios')
      } else {
        this.$parent.$parent.$data.showModalLoader = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/usuarios/Detalhes.vue